import bootbox from 'bootbox'



$('a.popin, .popin a').click(function(e) {
    e.preventDefault();

    let thisUrl = $(this).attr('href')
    Drupal.ajax({
        url: thisUrl,
        success: function(response) {

            $.fancybox.open({
                type: 'html',
                src  : response[1].data,
            });

        }
    }).execute();


})



// WEBPACK FOOTER //
// ./web/themes/custom/atolbtob/js/components/popin.js